import React         from "react";
import ReactDOM      from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider }  from "@azure/msal-react";
import msalInstance       from "./auth/msal";
import App                from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the app immediately — MsalProvider handles the "initializing" state
// internally and will re-render once MSAL is ready
root.render(
  <MsalProvider instance={msalInstance}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </MsalProvider>
);

// Initialize MSAL and process any redirect response in the background
// This does NOT block the initial render
msalInstance.initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then((response) => {
    if (response?.account) {
      // Redirect login just completed — set the active account
      msalInstance.setActiveAccount(response.account);
    }
  })
  .catch((error) => {
    console.error("MSAL initialization error:", error);
  });